import React, {Fragment} from 'react';
import {connect} from "react-redux";
import {useMediaQuery} from "beautiful-react-hooks";
import Infotip from "../global/Infotip";

const QuestionAnswerFooter = (props) => {
    const isTablet = useMediaQuery('(max-width: 1023px)');

    return (
        <Fragment>
            <div className="info">
                {props.name}
                <span className="info__number">
                    {props.selectedQuestion + 1}/{props.totalQuestions}
                </span>
            </div>
            <div className="text">
                <Infotip>
                    {isTablet &&
                        <p><mark>Tyle osób odpowiedziało jak Ty.</mark></p>
                    }
                    <small>
                        Twoje odpowiedzi porównywane są do wyników sondażu zrealizowanego
                        na ogólnopolskiej próbie Polaków (09.2019)
                    </small>
                </Infotip>
            </div>

            <div className="actions">
                {(props.selectedQuestion > 0) &&
                    <button className="btn btn--secondary btn--round" onClick={props.prev}>
                        <svg viewBox="0 0 32 32">
                            <g transform="rotate(-180) translate(-32, -31)">
                                <path fill="#fff" d="M19.414 27.414l10-10c0.781-0.781 0.781-2.047 0-2.828l-10-10c-0.781-0.781-2.047-0.781-2.828 0s-0.781 2.047 0 2.828l6.586 6.586h-19.172c-1.105 0-2 0.895-2 2s0.895 2 2 2h19.172l-6.586 6.586c-0.39 0.39-0.586 0.902-0.586 1.414s0.195 1.024 0.586 1.414c0.781 0.781 2.047 0.781 2.828 0z"></path>
                            </g>
                        </svg>
                    </button>
                }

                <button className="btn btn--secondary btn--round" onClick={props.next}>
                    <svg viewBox="0 0 32 32">
                        <path fill="#fff" d="M19.414 27.414l10-10c0.781-0.781 0.781-2.047 0-2.828l-10-10c-0.781-0.781-2.047-0.781-2.828 0s-0.781 2.047 0 2.828l6.586 6.586h-19.172c-1.105 0-2 0.895-2 2s0.895 2 2 2h19.172l-6.586 6.586c-0.39 0.39-0.586 0.902-0.586 1.414s0.195 1.024 0.586 1.414c0.781 0.781 2.047 0.781 2.828 0z"></path>
                    </svg>
                </button>
            </div>
        </Fragment>
    );
};

const mapStateToProps = state => {
    return {
        selectedQuestion: state.globals.selectedQuestion,
        totalQuestions: state.globals.totalQuestions,
    };
};


export default connect(mapStateToProps)(QuestionAnswerFooter);


// WEBPACK FOOTER //
// ./sources/js/components/Question/QuestionAnswerFooter.js